<script lang="ts" setup>
import { computed } from 'vue';
import { MAX_NAME_LENGTH } from '@/constants';
import { NotificationGroupInvitationType } from '@/types';
import { formatUserName } from '@/utils/formatters';
import CardTemplate from './card-template.vue';

// WARN: 通知の表記を変更するときは serviceWorkerHelper.ts の変更漏れがないかも確認する
// WARN: 通知のURLを変更するときは web-push.vue の変更漏れがないかも確認する

interface Props {
  notification: NotificationGroupInvitationType;
  isUnread: boolean;
}

const props = defineProps<Props>();

const url = computed(() => `/groups/${props.notification.group.id}`);
const formattedUserName = computed(() =>
  formatUserName(
    props.notification.creator_name,
    props.notification.is_deleted_creator,
    MAX_NAME_LENGTH,
  ),
);
</script>
<template>
  <CardTemplate
    :type="notification.type"
    :url="url"
    :is-unread="isUnread"
    :created-at="notification.created_at"
    :user-id="notification.creator_id"
    :image-url="notification.creator_image_url"
  >
    {{ formattedUserName }}さんが、あなたをグループ「{{
      notification.group.name
    }}」に追加しました。
  </CardTemplate>
</template>
